export class ExpressionError extends Error {
    constructor(message, errorParams) {
        super(message);
        this._errorParams = errorParams;
    }
    get errorParams() {
        return this._errorParams;
    }
}
//# sourceMappingURL=expressionError.js.map